import { Map } from 'immutable';

import {
    START_IMPLICIT_WAITING,
    SHOW_IMPLICIT_WAITING,
    STOP_IMPLICIT_WAITING,
    RESET_IMPLICIT_WAITING,
} from './actions';

const notWaiting = Map({
    waiting: false,
    visible: false,
    waitingCount: 0,
});

export function implicitWaitReducer(state = notWaiting, action) {
    switch (action.type) {
        case START_IMPLICIT_WAITING:
            return state.set('waiting', true).update('waitingCount', x => x + 1);
        case SHOW_IMPLICIT_WAITING:
            return state.set('visible', true);
        case STOP_IMPLICIT_WAITING:
            const waitingCount = state.get('waitingCount');
            if (waitingCount === 0) {
                return state;
            } else if (waitingCount === 1) {
                return notWaiting;
            } else {
                return state.set('waitingCount', waitingCount - 1);
            }
        case RESET_IMPLICIT_WAITING:
            return notWaiting;
    }
    return state;
}
